export default "__VITE_ASSET__5tvyB0sx__"